import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserProfile } from 'app/pages/Layout/slice/selectors';
import { useCommentSlice } from '../CommentState';
import { ExtendedComment } from '../types';

export const useReplyMenuActionHandlers = () => {
  const loggedInUser = useSelector(selectUserProfile);
  const dispatch = useDispatch();
  const { actions } = useCommentSlice();

  const [replyToDelete, setReplyToDelete] = useState<{
    reply: ExtendedComment;
    parentCommentId: string;
  } | null>(null);

  // Handle delete confirmation
  const handleConfirmDelete = () => {
    if (replyToDelete) {
      dispatch(
        actions.deleteReply({
          commentId: replyToDelete.reply.id,
          userId: loggedInUser.uid,
          parentCommentId: replyToDelete.parentCommentId
        })
      );
    }
    setReplyToDelete(null);
  };

  // Handle delete cancellation
  const handleCancelDelete = () => {
    setReplyToDelete(null);
  };

  // Handle reply menu actions
  const handleReplyMenuAction = (
    action: string,
    reply: ExtendedComment,
    parentCommentId: string
  ) => {
    switch (action) {
      case 'delete':
        setReplyToDelete({ reply, parentCommentId });
        break;
      // Note: In timestamp approach, "mark as read" is handled at the main comment level
      // Individual replies don't have separate read actions since the entire thread
      // is marked as read with one timestamp
      default:
        alert(`Custom reply action "${action}" performed on reply ${reply.id}`);
    }
  };

  return {
    handleReplyMenuAction,
    replyDeleteDialog: {
      isOpen: replyToDelete !== null,
      onConfirm: handleConfirmDelete,
      onCancel: handleCancelDelete
    }
  };
};
